import MutateCustomerCategoryDialog from './MutateCustomerCategoryDialog';

export default MutateCustomerCategoryDialog;
